function retain(resource) {
  resource._refCount = (resource._refCount ?? 1) + 1;
}
function release(resource) {
  const count = resource._refCount;
  if (count === void 0 || count <= 1) {
    return true;
  }
  resource._refCount = count - 1;
  return false;
}

export { release, retain };
//# sourceMappingURL=ref-count.js.map
